(function () {
  var DEBOUNCE_MS = 280;
  var searchUtils = window.CiSearchUtils || {};
  var MIN_CHARS = searchUtils.MIN_CHARS || 4;
  var normalize = searchUtils.normalize || function (value) {
    return (value || '').trim();
  };
  var isSearchableQuery =
    searchUtils.isSearchableQuery ||
    function (query) {
      return normalize(query).length >= MIN_CHARS;
    };

  function debounce(fn, wait) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function parseHandleSet(raw) {
    var set = new Set();
    (raw || '')
      .split(',')
      .forEach(function (handle) {
        handle = handle.trim().toLowerCase();
        if (handle) set.add(handle);
      });
    return set;
  }

  function parseCountFromGrid(gridContainer) {
    if (!gridContainer) return 0;
    var shell = gridContainer.querySelector('[data-ci-load-more-root]');
    if (shell) {
      return parseInt(shell.getAttribute('data-ci-search-results-count') || '0', 10) || 0;
    }
    return gridContainer.querySelectorAll('[data-brand-product], [data-ci-load-more-item]').length;
  }

  function updateCount(section, count, isFiltered) {
    var countValueEl = section.querySelector('[data-brand-count-value]');
    var countEl = section.querySelector('[data-brand-count]');
    if (!countValueEl) return;

    if (!countValueEl.dataset.baseCount) {
      countValueEl.dataset.baseCount = countValueEl.textContent;
    }

    countValueEl.textContent = isFiltered ? String(count) : countValueEl.dataset.baseCount;
    if (countEl) countEl.classList.toggle('is-filtered', !!isFiltered);
  }

  function filterShellToCollection(shell, handleSet) {
    if (!shell || !handleSet || !handleSet.size) return 0;

    var list = shell.querySelector('[data-brand-grid-list]');
    if (!list) return 0;

    var visible = 0;
    list.querySelectorAll('[data-ci-load-more-item]').forEach(function (item) {
      var handle = (item.getAttribute('data-product-handle') || '').trim().toLowerCase();
      if (!handle || !handleSet.has(handle)) {
        item.remove();
      } else {
        visible += 1;
      }
    });

    var noResults = shell.querySelector('[data-brand-no-results]');
    if (noResults) {
      noResults.hidden = visible > 0;
    }

    var loadMore = shell.querySelector('[data-ci-load-more]');
    if (loadMore) {
      loadMore.hidden = visible === 0;
    }

    shell.setAttribute('data-ci-search-results-count', String(visible));
    shell.setAttribute('data-ci-scoped-collection-search', 'true');
    return visible;
  }

  function initCollectionSearch(section) {
    var gridContainer = section.querySelector('#ProductGridContainer');
    var searchInput = section.querySelector('.ci-brand-collection-search');
    if (!gridContainer || !searchInput) return;

    if (searchInput.dataset.ciCollectionSearchReady === 'true') return;
    searchInput.dataset.ciCollectionSearchReady = 'true';

    var collectionSectionId = section.dataset.ciBrandSectionId || '';
    var globalSearchSectionId = section.dataset.ciSearchSectionId || 'ci-collection-search';
    var globalSearchUrl = section.dataset.ciSearchUrl || '/search';
    var collectionBrowseUrl = section.dataset.ciCollectionBrowseUrl || window.location.pathname;
    var collectionScope = section.dataset.ciCollectionScope || 'collection';
    var isCatalogScope = collectionScope === 'catalog';
    var handlesSource = section.querySelector('[data-ci-collection-product-handles]');
    var collectionHandleSet = isCatalogScope
      ? null
      : parseHandleSet(
          (handlesSource && handlesSource.getAttribute('data-ci-collection-product-handles')) ||
            section.dataset.ciCollectionProductHandles ||
            ''
        );
    var noResultsText =
      section.dataset.ciNoResultsText || 'No se encontraron productos con ese nombre.';
    var controller = null;
    var requestId = 0;

    if (!section.dataset.ciCollectionGridHtml) {
      section.dataset.ciCollectionGridHtml = gridContainer.innerHTML;
    }

    function clearClientSearchFlags() {
      section.querySelectorAll('[data-brand-product]').forEach(function (item) {
        item.removeAttribute('data-ci-search-hidden');
        item.removeAttribute('hidden');
        item.classList.remove('is-ci-load-more-hidden');
      });
      section.classList.remove('is-search-empty');
    }

    function afterGridSwap() {
      clearClientSearchFlags();

      if (section._ciFilters && typeof section._ciFilters.syncVisibility === 'function') {
        section._ciFilters.syncVisibility();
      }

      document.dispatchEvent(
        new CustomEvent('ci:collection-grid:updated', {
          detail: { section: section },
        })
      );
      document.dispatchEvent(
        new CustomEvent('ci:product-grid:updated', {
          detail: { root: gridContainer },
        })
      );
    }

    function buildSearchUrl(query, page, withSectionId) {
      var cleanQuery = normalize(query);
      var searchUrl = new URL(globalSearchUrl, window.location.origin);
      if (searchUtils.applyProductSearchParams) {
        searchUtils.applyProductSearchParams(searchUrl.searchParams, cleanQuery);
      } else {
        searchUrl.searchParams.set('type', 'product');
        searchUrl.searchParams.set('options[unavailable_products]', 'show');
        searchUrl.searchParams.set('options[prefix]', 'last');
        searchUrl.searchParams.set('q', cleanQuery);
      }

      if (withSectionId !== false) {
        searchUrl.searchParams.set('section_id', globalSearchSectionId);
      }

      if (page && page > 1) searchUrl.searchParams.set('page', String(page));
      return searchUrl;
    }

    function buildCollectionUrl() {
      var url = new URL(collectionBrowseUrl, window.location.origin);
      if (collectionSectionId) url.searchParams.set('section_id', collectionSectionId);
      var current = new URLSearchParams(window.location.search);
      current.forEach(function (value, key) {
        if (key === 'page' || key === 'section_id' || key === 'q') return;
        url.searchParams.append(key, value);
      });
      return url;
    }

    function extractGridShell(doc) {
      if (!doc) return null;

      var remoteGrid = doc.getElementById('ProductGridContainer');
      if (remoteGrid) {
        return (
          remoteGrid.querySelector('[data-ci-load-more-root]') ||
          remoteGrid.querySelector('.ci-cbg__grid-shell') ||
          remoteGrid
        );
      }

      return (
        doc.querySelector('[data-ci-load-more-root]') ||
        doc.querySelector('.ci-cbg__grid-shell')
      );
    }

    function fetchHtml(url) {
      if (controller) controller.abort();
      controller = new AbortController();
      requestId += 1;
      var currentRequestId = requestId;

      section.classList.add('is-ci-search-loading');

      return fetch(url.toString(), {
        signal: controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Request failed');
          return response.text();
        })
        .then(function (html) {
          if (currentRequestId !== requestId) return null;
          return new DOMParser().parseFromString(html, 'text/html');
        })
        .finally(function () {
          if (currentRequestId === requestId) {
            section.classList.remove('is-ci-search-loading');
          }
        });
    }

    function restoreCollection() {
      var query = normalize(searchInput.value);
      if (isSearchableQuery(query)) return;

      section.classList.remove('is-ci-remote-search');
      section.classList.remove('is-search-empty');

      return fetchHtml(buildCollectionUrl()).then(function (doc) {
        if (!doc) return;
        var next = doc.getElementById('ProductGridContainer');
        if (!next) return;
        gridContainer.innerHTML = next.innerHTML;
        updateCount(section, parseCountFromGrid(gridContainer), false);
        afterGridSwap();
      });
    }

    function runSearch(query) {
      var cleanQuery = normalize(query);

      if (!isSearchableQuery(cleanQuery)) {
        return restoreCollection();
      }

      section.classList.add('is-ci-remote-search');
      section.classList.add('is-ci-search-loading');

      if (!window.CiClientSearch || typeof window.CiClientSearch.renderCollectionGrid !== 'function') {
        section.classList.remove('is-ci-search-loading');
        window.location.href = buildSearchUrl(cleanQuery, null, false).toString();
        return;
      }

      var searchOptions = {
        query: cleanQuery,
        gridContainer: gridContainer,
        noResultsText: noResultsText,
        publishedHandles: section.dataset.ciPublishedBrandHandles || '',
      };

      if (!isCatalogScope && collectionHandleSet && collectionHandleSet.size) {
        searchOptions.handleSet = collectionHandleSet;
      }

      return window.CiClientSearch.renderCollectionGrid(cleanQuery, searchOptions)
        .then(function (count) {
          updateCount(section, count, true);
          afterGridSwap();
        })
        .finally(function () {
          section.classList.remove('is-ci-search-loading');
        });
    }

    var queueSearch = debounce(function () {
      runSearch(searchInput.value);
    }, DEBOUNCE_MS);

    searchInput.addEventListener('input', queueSearch);
    searchInput.addEventListener('search', function () {
      runSearch(searchInput.value);
    });

    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        searchInput.value = '';
        restoreCollection();
      }
    });
  }

  document.querySelectorAll('[data-ci-brand-grid]').forEach(initCollectionSearch);

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target.querySelector('[data-ci-brand-grid]') || event.target.closest('[data-ci-brand-grid]');
    if (section) initCollectionSearch(section);
  });
})();
